(function () {
  var watchedList = null;
  var galleryObserver = null;

  function syncFirstGalleryImage() {
    var thumbnail = document.querySelector(
      '.product-gallery__thumbnail-list ' +
      'a.product-gallery__thumbnail:first-child img'
    );

    if (!thumbnail) return;

    var thumbnailLink = thumbnail.closest(
      'a.product-gallery__thumbnail'
    );

    var mediaId = thumbnailLink
      ? thumbnailLink.getAttribute('data-media-id')
      : null;

    var mainImage = mediaId
      ? document.querySelector(
          '.product-gallery__carousel-item[data-media-id="' +
          mediaId +
          '"] img.product-gallery__image'
        )
      : null;

    var imageSource =
      thumbnail.getAttribute('src') ||
      thumbnail.currentSrc ||
      thumbnail.getAttribute('data-zoom');

    if (!mainImage || !imageSource) return;

    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.removeAttribute('data-src');
    mainImage.removeAttribute('data-srcset');

    mainImage.setAttribute('src', imageSource);
    mainImage.setAttribute('data-zoom', imageSource);

    var imageLink = mainImage.closest('a');

    if (imageLink) {
      imageLink.setAttribute('href', imageSource);
      imageLink.setAttribute('data-zoom-image', imageSource);
    }
  }

  function installWatcher() {
    var currentList = document.querySelector(
      '.product-gallery__thumbnail-list'
    );

    /*
     * Apippa/Warehouse has not built the gallery yet.
     */
    if (!currentList) return;

    /*
     * Do nothing when we are already watching the current gallery.
     */
    if (currentList === watchedList && galleryObserver) return;

    /*
     * Warehouse may replace the gallery after initial loading.
     * Disconnect from the old version and attach to the new one.
     */
    if (galleryObserver) {
      galleryObserver.disconnect();
    }

    watchedList = currentList;

    galleryObserver = new MutationObserver(function () {
      window.setTimeout(syncFirstGalleryImage, 50);
    });

    galleryObserver.observe(currentList, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-zoom']
    });

    syncFirstGalleryImage();

    console.log(
      'Direct Carpets: Warehouse image watcher installed'
    );
  }

  /*
   * Keep checking because Apippa and Warehouse both load and
   * replace parts of the product page asynchronously.
   */
  window.setInterval(installWatcher, 500);

  /*
   * Also try immediately when the page has loaded.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installWatcher);
  } else {
    installWatcher();
  }
})();
